import React, { useState, useEffect, useRef } from "react";
import "./uploadDbModal.css";
import useApiRequests from "../../hooks/useApiRequests.tsx";
import { FillingBottle } from "react-cssfx-loading";
import { useNotification } from "../../hooks/useNotification";
import { IPartnerWhiteLabel } from "../../interfaces/IPartnerWhiteLabel.tsx";
import { IPartnerCustomerRelationship  } from "../../interfaces/ITask.tsx";
import { IStatusUploadHomologacao  } from "../../interfaces/IUploadHomologacao.tsx"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter} from "reactstrap";
// import '../../styles/dark-theme.css'
import Title from '../Text/Title/Title.jsx';
import { useTheme } from '../../Context/ThemeContext';


interface UploadDbModalProps {
  isOpen: boolean;
  partnerCustomer: IPartnerCustomerRelationship[]
  taskId: string
  toggleUploadDbModal: () => void;
}


const UploadDbModal: React.FC<UploadDbModalProps> = ({
  isOpen,
  partnerCustomer,
  taskId,
  toggleUploadDbModal,
}) => {

  const { theme, toggleTheme } = useTheme();

  const { notify } = useNotification();

  const { uploadHomologacao, getStatusUploadHomologacao, getWhiteLabels } =
    useApiRequests();

  const [partnerList, setPartnerList] = useState<IPartnerWhiteLabel[]>([]);
  const [selectedCustomers, setSelectedCustomers] = useState<IPartnerWhiteLabel[]>([]);

  const [isUploadingDb, setIsUploadingDb] = useState(false);
  const [uploadingDbStatus, setUploadingDbStatus] = useState("");
  const [downloadSuccess, setDownloadSuccess] = useState(false);
  const [showCopiarUrl, setShowCopiarUrl] = useState(false);
  const [closeModalBtn, setCloseModalBtn] = useState(true);
  const [disableBtn, setDisableBtn] = useState(false);

  const [finishedUpload, setFinishedUpload] = useState('');

  // Criando uma referência para a tag span
  const finishedUploadValues = useRef<HTMLDivElement>(null);

  // Atualizando o conteúdo da tag span sempre que o estado "valor" mudar
  useEffect(()=> {
    setDisableBtn(false)
  })

  useEffect(() => {
    if (finishedUploadValues.current) {
      finishedUploadValues.current.textContent = finishedUpload;
    }
  }, [finishedUpload]);


  useEffect(() => {
    // MONTAGEM
    setIsUploadingDb(false);
    setShowCopiarUrl(false);
    setIsUploadingDb(false);
    setCloseModalBtn(true);

    return () => {
      // DESMONTAGEM
      setShowCopiarUrl(false);
      setIsUploadingDb(false);
      setCloseModalBtn(true);
    };
  }, [isOpen]);

  useEffect(() => {
    const fetchWhiteLabel = async () => {
      try {
        let emails: string[] = []
        partnerCustomer.forEach(pc => emails.push(pc.customerEmail))

        const data = await getWhiteLabels(emails);
        if (data.success) {
          let list: IPartnerWhiteLabel[] = [];
          let i = 0;

          for (let i = 0; i < data.data.length; i++) {
            list.push({
              key: i,
              email: data.data[i].email as string,
              selected: false,
              url: data.data[i].url,
              whitelabel: data.data[i].whitelabel,
            });
          }
          setPartnerList(list);
        }
      } catch (er) {
      }
    };
    if (isOpen === true) fetchWhiteLabel();
  }, [isOpen]);



  useEffect( () => {
    setDisableBtn(true)
    
    const iniciarUpload = async () => {
      for (let i = 0; i < selectedCustomers.length; i++) {
        try {
          let customerEmail = selectedCustomers[i].email
          let whitelabel = selectedCustomers[i].whitelabel
          let partnerEmailObj = partnerCustomer.find(pc => pc.customerEmail === customerEmail)
  
  
          let partnerEmail = partnerEmailObj?.partnerEmail || ""
          let newStatusUpload: IStatusUploadHomologacao = {
            customerEmail: customerEmail,
            whitelabel: whitelabel,
            partnerEmail: partnerEmail,
            taskId: taskId
          }
  
          const data = await uploadHomologacao(newStatusUpload);
  
          if (data.success && data.data.processoId) {
  
  
            setUploadingDbStatus(data.data.processoStatus);
            setIsUploadingDb(data.success);
            setCloseModalBtn(!data.success);
  
            await getStatusUpload(data.data.processoId);
            // notify("Subindo base para homologação");
          } else {
            notify(data.msg, { type: "error" });
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    iniciarUpload()
    

  },[selectedCustomers])

    const handleUploadHomologacao =async () => {
      const selecionados = partnerList.filter((p) => p.selected === true);
      if (selecionados.length > 0) {
        setDisableBtn(true);
        setPartnerList(selecionados)
        setSelectedCustomers(selecionados)
        setShowCopiarUrl(true);
      } else {
        notify("Você não selecionou nenhum email.", { type: "error" });
        return;
      }
  };


  const getStatusUpload = async (id: string) => {
    try {
      const data = await getStatusUploadHomologacao(id);

      setIsUploadingDb(data.success);
      setUploadingDbStatus(data.data.processoStatus);

      setDownloadSuccess(data.success && data.data.concluida);

      if (data.success && !data.data.concluida) {

        

        setTimeout(() => {
          getStatusUpload(id);
        }, 3000);


      } else if (data.data.concluida) {
        const finishedUploadsDiv = document.getElementById('finished-uploads');
        if (finishedUploadsDiv && data.data.msgFinishedUpload) {
          finishedUploadsDiv.innerText = `${finishedUploadsDiv?.innerText}\n${data.data.msgFinishedUpload}`;
        }


        setTimeout(() => setIsUploadingDb(false), 3000);
        setCloseModalBtn(true);

      }
    } catch (error) {
      notify(error, { type: "error" });
    }
  };

  const copiarUrl = (url:string, tipo:string) => {
    navigator.clipboard.writeText(url)
    notify(`A URL para o ${tipo} em homologação foi copiada, basta colar essa URL no navegador`, {type:"success"})
  }

  const handleCheckboxChange = (key: number) => {
    setPartnerList((prevItens: IPartnerWhiteLabel[]) =>
      prevItens.map((item) =>
        item.key === key ? { ...item, selected: !item.selected } : item
      )
    );
  };

  return (
    <div className='dark' id="modal-style-container">
      <Modal 
      isOpen={isOpen} 
      id="modal-style-upload-db" 
      className={`${localStorage.getItem('mode') ? localStorage.getItem('mode') : 'light'}`}>
        <ModalHeader 
        id="header-upload-db-modal" >
          {closeModalBtn && (
            <button onClick={() => toggleUploadDbModal()} id="close-modal">
              X
            </button>
          )}

          <span >Clonar base(s) para o ambiente de homologação</span>
        </ModalHeader>
        <ModalBody 
        id="body-upload-db-modal" 
        className={`${localStorage.getItem('mode') ? localStorage.getItem('mode') : 'light'}`}
        >
            <div style={{ marginBottom:"20px", textAlign:"center" }} >

              <span className="theme-text-color" style={{fontSize:20}}>Selecione a(s) base(s) que você deseja clonar</span>
              </div>

          <div className="flex-container">
            <ul>
              {partnerList.map((partner) => (
                <li id="item-emails-list" key={partner.key}>

                  <div className="emails-container">
                    <input
                      className="input-email form-check-input"
                      type="checkbox"
                      checked={partner.selected}
                      onChange={() => handleCheckboxChange(partner.key)}
                    />
                    <span className="theme-text-color">{partner.email}</span>
                  </div>

                  {showCopiarUrl && (
                    <div className="btns-copy-url-container">
                      <button
                        className="btn-copiar-url"
                        onClick={() => {
                          let partnerEmail = partnerCustomer.find((pc) => pc.customerEmail === partner.email)?.partnerEmail
                          copiarUrl(`https://painel.vendaerp.com/Login.aspx?s1tt1ngbull=${partnerEmail}`, "Painel")
                        }
                         }
                      >
                        URL Painel
                      </button>

                      <button
                        className="btn-copiar-url"
                        onClick={() => copiarUrl(`${partner.url}s1tt1ngbull=${partner.email}`, "ERP")}                      >
                        URL ERP
                      </button>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
          

          {isUploadingDb ? (
            <div
              id="loading-container"
              className="d-flex flex-column text-center align-items-center  "
            >
              {!downloadSuccess && (
                <span className="text-center justify-content-center">
                  <FillingBottle
                    className="mx-auto mt-2"
                    width="100px"
                    height="100px"
                    color="#dddcdc"
                  />
                  <p className="upload-loading mt-4">
                    Por favor, não feche esta guia durante a execução desse
                    processo
                  </p>
                </span>
              )}
            </div>
          ) : (
            <Button
              disabled={disableBtn}
              id="btn-upload-db"
              color="success"
              style={{ height: "48px" }}
              onClick={() => handleUploadHomologacao()}
            >
              Clonar base(s)
            </Button>
          )}

          
          <div className="text-center">
            <p className="upload-loading">{uploadingDbStatus}</p>
          </div>
          <div id="finished-uploads" className="text-success text-center m-auto"></div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default UploadDbModal;
